var storefrontApp = angular.module('storefrontApp');
storefrontApp.controller('projectCategoriesController', ['$scope', '$window',
    function ($scope, $window) {

        //#region Initialization
        $scope.searchCategory = "";
        $scope.$parent.enableScrollToTop = true;
        //#endregion

        $scope.initializeCategories = function () {
            if(angular.isDefined($window.allProjectCategories)){
                $scope.allProjectCategories = $window.allProjectCategories;
            }
            if(angular.isDefined($window.allProjectParentCategories)){
                $scope.allProjectParentCategories = $window.allProjectParentCategories;
            }
        }
      
    }])
